import React from "react";
import "./metered-story-indicator.m.css";
import { CloseIcon } from "../../../../assets/icons/social/close";
import { Link } from "@quintype/components";
import get from "lodash/get";
import { connect } from "react-redux";
import PropTypes from "prop-types";

class MeteredStoryIndicatorBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showForm: true
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.meteringCount !== prevProps.meteringCount) {
      this.showForm();
    }
  }

  showForm = () => {
    this.setState({ showForm: true });
  };

  hideForm = event => {
    event.stopPropagation();
    event.preventDefault();
    this.setState({ showForm: false });
  };

  openLogin = event => {
    event.preventDefault();
    event.stopPropagation();
    this.props.openLoginTemplate();
  };

  render() {
    if (!this.state.showForm || this.props.meteringCount <= 0) return null;

    return (
      <div>
        <div styleName="metered-wrapper">
          <p styleName="metered-desc">
            You have {this.props.meteringCount} more free stories left. Subscribe us to continue unlimited access to all
            our stories.
          </p>
          <div styleName="btn-wrapper">
            <div styleName="subscribe-btn">
              <Link href={"/subscription"}>Subscribe</Link>
            </div>
            {!this.props.member && (
              <span styleName="info-text">
                Already a user? <a onClick={this.openLogin}>Login</a>
              </span>
            )}
          </div>
          <div onClick={this.hideForm}>
            <CloseIcon width="24" height="24" color={"#333"} />
          </div>
        </div>
      </div>
    );
  }
}

MeteredStoryIndicatorBase.propTypes = {
  meteringCount: PropTypes.number,
  member: PropTypes.object,
  openLoginTemplate: PropTypes.func
};

const mapStateToProps = state => ({
  meteringCount: get(state, ["meteringCount"]),
  member: get(state, ["member"], null)
});

const mapDispatchToProps = dispatch => ({
  openLoginTemplate: () => dispatch({ type: "OPEN_LOGIN_TEMPLATE" })
});

export const MeteredStoryIndicator = connect(
  mapStateToProps,
  mapDispatchToProps
)(MeteredStoryIndicatorBase);
